import { FC, PropsWithChildren } from "react";
import { NavPages } from "../../widgets/nav";
import classes from './layoutPages.module.scss'
import { Link } from "react-router-dom";
import { LAYOUT_PAGE_SCROLL_ID } from "../../shared/lib/helpers/scrollLayoutToTop";
import { useLayoutNavigation } from "./useLayoutNavigation";
import { RECEIPT_HEADER_ID } from "../../shared/lib/const/receiptEvents";

interface IProps {
    title: string;
    titleLink?: string;
}

export const LayoutPages: FC<IProps & PropsWithChildren> = ({title, titleLink, children}) => {
    const {isMobile, navOpen, toggleNav, closeMobileNav} = useLayoutNavigation()

    return (
        <section className={classes.layout}>
            <header className={classes.header}>
                <section className={classes.headerLeft}>
                    <button
                        className={classes.burger}
                        onClick={toggleNav}
                        aria-label="Открыть навигацию"
                        aria-controls="layout-navigation"
                        aria-expanded={navOpen}
                    >
                        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 18L20 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            <path d="M4 12L20 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            <path d="M4 6L20 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                    </button>
                    {
                        titleLink
                            ?
                        <Link to={titleLink} className={classes.title}>{title}</Link>
                            :
                        <section className={classes.title}>{title}</section>
                    }
                </section>
                <section id={RECEIPT_HEADER_ID} className={classes.headerWarning} />
            </header>
            <section className={classes.body}>
                <aside id="layout-navigation" className={classes.nav + (navOpen ? ` ${classes.open}` : '')}>
                    <section className={classes.navPagesWrap}>
                        <NavPages onReplacePath={closeMobileNav} />
                    </section>
                </aside>
                <button
                    type="button"
                    aria-label="Закрыть навигацию"
                    className={classes.darken + (isMobile && navOpen ? ` ${classes.open}` : '')}
                    onClick={closeMobileNav}
                />
                <section id={LAYOUT_PAGE_SCROLL_ID} className={classes.container}>
                    <main className={classes.main}>
                        {children}
                    </main>
                </section>
            </section>
        </section>
    )
}
